import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';

const MainContent = ({ children }: { readonly children: ReactNode }) => {
  const t = useTranslations();

  return (
    <main
      aria-label={t('main_content')}
      data-cy="main-content"
      id="main-content" // needed for "skip to content" link
      tabIndex={-1} // makes the element focusable without including it in the tab order
    >
      {children}
    </main>
  );
};

export default MainContent;
